import Add16 from '@carbon/icons-react/es/add/16';
import { faBooks, faRulerTriangle } from '@fortawesome/pro-duotone-svg-icons';
import { useBoolean } from 'ahooks';
import { Space } from 'antd';
import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ProjectId } from 'api/models';
import {
  EmptyState,
  EmptyStateContainer as EmptyStateContainerAtom,
  EmptyStateIcon,
} from 'components/atoms/empty-state';
// import { KBLinks } from 'constant';
import { SwitchContentBasedOnAccess } from 'components/organisms/permission-controller';
import { PermissionRuleName } from 'constant';
import { useCurrentProject } from 'hooks/use-current-project';
import { ImportFromTemplate } from './import-from-template';
import { ProjectPhaseModal } from './project-phase-modal';

const EmptyStateContainer = styled(EmptyStateContainerAtom)`
  height: 100%;
  padding-right: var(--spacing-05);
`;

export const ProjectPlanEmptyState: FC = () => {
  const project = useCurrentProject();
  const [showCreatePhasePopup, setShowCreatePhasePopup] = useState(false);
  const [
    visible,
    { setTrue: openTemplatesDrawer, setFalse: closeTemplatesDrawer },
  ] = useBoolean(false);

  return (
    <SwitchContentBasedOnAccess
      ruleName={PermissionRuleName.ProjectPhaseCreateAction}
      hasAccess={
        <EmptyStateContainer>
          <Space size={64}>
            <EmptyState
              image={<EmptyStateIcon icon={faBooks} />}
              title={
                <FormattedMessage id="projects.plan.template.empty.title" />
              }
              message={
                <FormattedMessage id="projects.plan.template.empty.message" />
              }
              primaryCTA={
                <EmptyState.CallToAction.Primary
                  icon={<Add16 />}
                  onClick={openTemplatesDrawer}
                  data-cy="projects.plan.template.empty.primary"
                  ruleName={PermissionRuleName.ProjectPhaseCreateAction}
                >
                  <FormattedMessage id="projects.plan.template.empty.primary" />
                </EmptyState.CallToAction.Primary>
              }
              // secondaryCTA={
              //   <EmptyState.CallToAction.Secondary
              //     href={KBLinks.projectPlanTemplate}
              //     target="_blank"
              //   >
              //     <FormattedMessage id="projects.plan.template.empty.secondary" />
              //   </EmptyState.CallToAction.Secondary>
              // }
            />
            <ImportFromTemplate
              title={
                <FormattedMessage id="projects.plan.empty.choose.template" />
              }
              projectId={ProjectId(project.projectId)}
              visible={visible}
              onClose={closeTemplatesDrawer}
            />
            <EmptyState
              image={<EmptyStateIcon icon={faRulerTriangle} />}
              title={<FormattedMessage id="projects.plan.empty.title" />}
              message={<FormattedMessage id="projects.plan.empty.message" />}
              primaryCTA={
                <>
                  <EmptyState.CallToAction.Primary
                    icon={<Add16 />}
                    onClick={() => setShowCreatePhasePopup(true)}
                    data-cy="projects.plan.empty.primary"
                    ruleName={PermissionRuleName.ProjectPhaseCreateAction}
                  >
                    <FormattedMessage id="projects.plan.empty.primary" />
                  </EmptyState.CallToAction.Primary>
                  <ProjectPhaseModal
                    visible={showCreatePhasePopup}
                    projectId={ProjectId(project.projectId)}
                    onClose={() => setShowCreatePhasePopup(false)}
                  />
                </>
              }
              // secondaryCTA={
              //   <EmptyState.CallToAction.Secondary
              //     href={KBLinks.projectPlan}
              //     target="_blank"
              //   >
              //     <FormattedMessage id="projects.plan.empty.secondary" />
              //   </EmptyState.CallToAction.Secondary>
              // }
            />
          </Space>
        </EmptyStateContainer>
      }
      doesNotHaveAccess={
        <EmptyStateContainer>
          <EmptyState
            image={<EmptyStateIcon icon={faRulerTriangle} />}
            title={<FormattedMessage id="projects.plan.customer.empty.title" />}
            message={
              <FormattedMessage id="projects.plan.customer.empty.message" />
            }
            // secondaryCTA={
            //   <EmptyState.CallToAction.Secondary
            //     href={KBLinks.projectPlanCustomer}
            //     target="_blank"
            //   >
            //     <FormattedMessage id="projects.plan.customer.empty.secondary" />
            //   </EmptyState.CallToAction.Secondary>
            // }
          />
        </EmptyStateContainer>
      }
    />
  );
};
